module.exports = __webpack_public_path__ + "static/faq3-0bbd46625903ed023d8d3fa035e6272a.svg";